import { Navigate, Route, Routes } from 'react-router-dom'

import { LandingPage } from './modules/landing'
import { SignupPage } from './modules/signup'
import { LoginPage } from './modules/login'
import { DashboardPage } from './modules/dashboard'
import { OnboardingPage } from './modules/onboarding'
import { CertPage } from './modules/cert'
import { ApiKeysPage } from './modules/api-keys'
import { UsagePage } from './modules/usage'
import { AuditHistoryPage } from './modules/audit-history'
import { DataExportPage } from './modules/data-export'
import { IntegrationGuidePage } from './modules/integration-guide'
import { SandboxPage } from './modules/sandbox'
import { ProtectedRoute } from './components/layout/protected-route'
import { ROUTES } from './lib/constants'

export default function App() {
  return (
    <Routes>
      {/* Públicas */}
      <Route path={ROUTES.LANDING} element={<LandingPage />} />
      <Route path={ROUTES.SIGNUP} element={<SignupPage />} />
      <Route path={ROUTES.LOGIN} element={<LoginPage />} />

      {/* Autenticadas */}
      <Route path={ROUTES.DASHBOARD} element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      <Route path={ROUTES.ONBOARDING} element={<ProtectedRoute><OnboardingPage /></ProtectedRoute>} />
      <Route path={ROUTES.CERT} element={<ProtectedRoute><CertPage /></ProtectedRoute>} />
      <Route path={ROUTES.API_KEYS} element={<ProtectedRoute><ApiKeysPage /></ProtectedRoute>} />
      <Route path={ROUTES.USAGE} element={<ProtectedRoute><UsagePage /></ProtectedRoute>} />
      <Route path={ROUTES.AUDIT_HISTORY} element={<ProtectedRoute><AuditHistoryPage /></ProtectedRoute>} />
      <Route path={ROUTES.DATA_EXPORT} element={<ProtectedRoute><DataExportPage /></ProtectedRoute>} />
      <Route path={ROUTES.INTEGRATION_GUIDE} element={<ProtectedRoute><IntegrationGuidePage /></ProtectedRoute>} />
      <Route path={ROUTES.SANDBOX} element={<ProtectedRoute><SandboxPage /></ProtectedRoute>} />

      <Route path="*" element={<Navigate to={ROUTES.LANDING} replace />} />
    </Routes>
  )
}
